let config = {
    buildNumber: "6550",
    cachedAPI: "https://foxone-internal-cached.api.viewlift.com",
    apiBaseUrl:"https://foxone-internal.api.viewlift.com",
    apiKey:  "WX41iaJiOw7hJW8sNbDP5JpVwmjaH6t6y3xbQUsc",
    appCMSBaseUrl: "https://appcms-foxone.asset.viewlift.com",
    buildAssetsUrl: "https://appcms-foxone.asset.viewlift.com",
    toolsUrl:"https://cms-foxone.prod.viewlift.com",
    internalEmbedBaseURL: "https://foxone-internal.api.viewlift.com",
    paymentWSUrl: "wss://prod-ws.viewlift.com/ws",
    filesProxy: {
        directPaths: [
          '/apple-app-site-association',
          '/.well-known/apple-app-site-association',
          '/.well-known/assetlinks.json',
          '/robots.txt',
          '/ads.txt',
          '/app-ads.txt',
          '/sitemap1.xml',
          '/sitemap2.xml',
          '/sitemap3.xml',
          '/sitemap4.xml',
          '/sitemap5.xml',
          '/sitemap6.xml',
          '/sitemap7.xml',
          '/sitemap8.xml',
          '/sitemap9.xml',
          '/sitemap10.xml',
          '/offline.html',
          '/serviceWorker.js',
          '/sw.js'
        ]
      },
    env:"prod"
   }
   module.exports.config = config;
  